<template>
  <v-card>
    <v-card-title>Adimplência</v-card-title>
    <v-card-text>
      <Chart :chartOptions="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "@/components/BaseChart";
import { mapGetters } from "vuex";
export default {
  components: {
    Chart
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: ""
        },

        chart: {
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: "350"
        },

        pane: {
          startAngle: -90,
          endAngle: 89.9,
          background: null,
          center: ["50%", "75%"],
          size: "110%"
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,
          tickPixelInterval: 50,
          tickPosition: "inside",
          tickColor: "#FFFFFF",
          tickLength: 20,
          tickWidth: 0,
          minorTickInterval: null,
          labels: {
            distance: 20,
            style: {
              fontSize: "14px"
            }
          },
          lineWidth: 0,
          plotBands: []
        },

        series: [],

        credits: {
          enabled: false
        },

        lang: {
          noData: "Não há dados para serem apresentados"
        },
        noData: {
          style: {
            fontWeight: "normal",
            fontSize: "1rem",
            color: "rgba(0, 0, 0, 0.6)"
          }
        }
      }
    };
  },

  computed: {
    ...mapGetters("relatorios", ["getRelatorios"]),
    ...mapGetters("adimplencia", ["getAdimplencia"])
  },

  watch: {
    getRelatorios(value) {
      this.chartOptions.series = [];
      this.setAdimplencia(value);
    },
    getAdimplencia(value) {
      this.chartOptions.yAxis.plotBands = [];
      this.setFaixas(value);
    }
  },

  methods: {
    setFaixas(adimplencia) {
      this.chartOptions.yAxis.plotBands.push({
        from: 0,
        to: 50,
        color: "#CC152C", // red
        thickness: 20
      });
      this.chartOptions.yAxis.plotBands.push({
        from: adimplencia[0].faixaAdimplencia2 - 1,
        to: adimplencia[0].faixaAdimplencia1,
        color: "#FFBA00", // yellow
        thickness: 20
      });
      this.chartOptions.yAxis.plotBands.push({
        from: adimplencia[0].faixaAdimplencia1,
        to: 100,
        color: "#00AB47", // green
        thickness: 20
      });
    },

    setAdimplencia(data) {
      this.chartOptions.series.push({
        name: "Adimplência",
        data: [data.adimplencia.PercAdimplencia],
        tooltip: {
          valueSuffix: "%"
        },
        dataLabels: {
          format: "{y}%",
          borderWidth: 0,
          color: "#333333",
          style: {
            fontSize: "16px"
          }
        },
        dial: {
          radius: "80%",
          backgroundColor: "gray",
          baseWidth: 12,
          baseLength: "0%",
          rearLength: "0%"
        },
        pivot: {
          backgroundColor: "gray",
          radius: 6
        }
      });
    }
  }
};
</script>

<style></style>